import { ISelectItem } from '@lla-platform/core/core-ui'

// Values match the BE C# enum member names — that's what JsonStringEnumConverter
// emits on the wire, so the FE can compare/round-trip without translation.
export enum UsafFillFlag {
  ShipComplete = 'ShipComplete',
  BackOrder = 'BackOrder',
  CancelLine = 'CancelLine',
  CancelOrder = 'CancelOrder',
  Cancel = 'Cancel'
}

export const UsafFillFlagItems: ISelectItem[] = [
  { value: UsafFillFlag.ShipComplete, label: 'Ship Complete' },
  { value: UsafFillFlag.BackOrder, label: 'Back Order' },
  { value: UsafFillFlag.CancelLine, label: 'Cancel Line' },
  { value: UsafFillFlag.CancelOrder, label: 'Cancel Order' },
  { value: UsafFillFlag.Cancel, label: 'Cancel' }
]
